
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_gu1xj_43",
  "spinner-rotator": "awsui_spinner-rotator_1612d_gu1xj_1",
  "size-x-small": "awsui_size-x-small_1612d_gu1xj_58",
  "size-normal": "awsui_size-normal_1612d_gu1xj_65",
  "size-big": "awsui_size-big_1612d_gu1xj_72",
  "size-large": "awsui_size-large_1612d_gu1xj_79",
  "variant-normal": "awsui_variant-normal_1612d_gu1xj_86",
  "variant-disabled": "awsui_variant-disabled_1612d_gu1xj_89",
  "variant-inverted": "awsui_variant-inverted_1612d_gu1xj_92",
  "circle": "awsui_circle_1612d_gu1xj_104",
  "circle-left": "awsui_circle-left_1612d_gu1xj_132",
  "spinner-line-left": "awsui_spinner-line-left_1612d_gu1xj_1",
  "circle-right": "awsui_circle-right_1612d_gu1xj_137",
  "spinner-line-right": "awsui_spinner-line-right_1612d_gu1xj_1"
};
  